import * as Styles from './MetricCard.styles';

const DEFAULT_ACCENT = '#054AD9';

export type MetricCardProps = {
  /** Descriptive label shown above the value (e.g. "Clicks", "Position"). */
  label: string;
  /** The metric value to display prominently. */
  value: string | number;
  /** Color applied to the value text. Defaults to the brand primary. */
  color?: string;
  /** Optional subtitle shown below the value (e.g. "GSC average"). */
  subtitle?: string;
  /** Show a skeleton placeholder instead of the value. */
  isLoading?: boolean;
  /** Apply a thicker border and tinted background to emphasize this card. */
  highlighted?: boolean;
  /** Optional indicator element rendered next to the label (e.g. a colored dot or spinner). */
  indicator?: React.ReactNode;
};

const MetricCard = function ({
  label,
  value,
  color = DEFAULT_ACCENT,
  subtitle,
  isLoading = false,
  highlighted = false,
  indicator,
}: MetricCardProps): JSX.Element {
  return (
    <Styles.Card $highlighted={highlighted} $accentColor={color}>
      <Styles.Label>
        {label}
        {indicator}
      </Styles.Label>

      {isLoading ? (
        <Styles.SkeletonValue />
      ) : (
        <Styles.Value $color={color}>{value}</Styles.Value>
      )}

      {subtitle && <Styles.Subtitle>{subtitle}</Styles.Subtitle>}
    </Styles.Card>
  );
};

export default MetricCard;
